// Data Model

export interface UserFromNolaNovel {
  id: string;
  name: string;
  profile: string;
  imagePath: string;
  usePurpose: string;
  followCount: number;
  followerCount: number;
  createdAt: number;
  updatedAt: number;
  novels: NovelFromNolaNovel[];
}

export interface NovelFromNolaNovel {
  id: string;
  title: string;
  imagePath: string;
  createdAt: number;
  updatedAt: number;
  novelIdsNola: string[];
  bookmarkCount: number;

  episodes?: EpisodeFromNolaNovel[];
}

export interface EpisodeFromNolaNovel {
  id: string;
  novelId: string;
  title: string;
  type: string;
  order: number;
  createdAt: number;
  updatedAt: number;
  publishedAt: number;
  characterCount: number;
  novelIdNola?: string;
  episodeIdNola?: string;

  novel?: NovelFromNolaNovel;
}

export interface AnalyticsFromNolaNovel {
  count: number;
  items: AnalyticsItem[];
}

export interface AnalyticsItem {
  targetId: string;
  typeTermDate: string;
  count: number;
  meta?: string;
  createdAt: number;
  updatedAt: number;
}

export interface ListAnalytics {
  [key: string]: AnalyticsFromNolaNovel;
}

export interface NotificationsFromNolaNovel {
  items: NotificationFromNolaNovel[];
  lastKey?: string;
}

export type NotificationFromNolaNovel = {
  novel?: {
    id: string;
    title: string;
  };
  episode?: {
    id: string;
    title: string;
  };
  comment?: {
    id: string;
    body: string;
  };
  user?: {
    id: string;
    name: string;
  };
  activity?: {
    id: string;
    title: string;
  };
  company?: {
    id: string;
    name: string;
  };
  userId: string;
  typeTargetIdSubTargetId: string;
  type: string;
  isRead: boolean;
  publishedAt: number;
};

// Input Model

export interface AnalyticsFromNolaNovelInput {
  targetId: string;
  type: AnalyticsDataType;
  term?: AnalyticsTerm;
  date?: string;
  start?: string;
  end?: string;
}

// Enum

export enum AnalyticsDataType {
  /**
   * 読了数
   */
  READ = "READ",
  /**
   * ページビュー数
   */
  PV = "PV",
  /**
   * ターゲットに関連する作品詳細画面PV数
   */
  PV_NOVEL = "PV_NOVEL",
  /**
   * ターゲットに関連する全エピソードPV数
   */
  PV_EPISODE = "PV_EPISODE",
  /**
   * 流入元がDIRECTのPV数
   */
  PV_DIRECT = "PV_DIRECT",
  /**
   * IMP数
   */
  IMP = "IMP",
  /**
   * ターゲットに関連する作品IMP数
   */
  IMP_NOVEL = "IMP_NOVEL",
  /**
   * みんなの評価数
   */
  REVIEW = "REVIEW",
  /**
   * ブックマーク数
   */
  BOOKMARK = "BOOKMARK",
  /**
   * コメント数
   */
  COMMENT = "COMMENT",
  /**
   * スタンプ数
   */
  STAMP = "STAMP",
}

export enum AnalyticsTerm {
  ALL = "ALL", // 全期間
  DAILY = "DAILY", // 日間のデータ
  MONTHLY = "MONTHLY", // 月間のデータ
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum NotificationSortType {
  PUBLISHED_AT = "PUBLISHED_AT",
}

export enum NotificationDataType {
  NOVEL_UPDATED = "NOVEL_UPDATED", // ブックマークした書籍が更新されました！
  FOLLOW_NEWNOVEL = "FOLLOW_NEWNOVEL", // フォローした作家さんの新作小説が投稿されました！
  FOLLOW_NEWEPISODE = "FOLLOW_NEWEPISODE", // フォローした作家さんの新作エピソードが投稿されました！
  FOLLOW_NEWACTIVITY = "FOLLOW_NEWACTIVITY",
  BOOKMARK = "BOOKMARK", // ブックマークされました！
  FOLLOW = "FOLLOW", // フォローされました！
  REVIEW = "REVIEW", // 作品に感想が届きました！
  COMMENT = "COMMENT", // コメントが届きました
  COMMENT_REPLY = "COMMENT_REPLY", // あなたのコメントに返信が届きました
  COMPANY_FOOTPRINTS = "COMPANY_FOOTPRINTS", // 編集部からあしあとがつきました！
  COMPANY_BOOKMARK = "COMPANY_BOOKMARK", // 編集部からブックマークがつきました！
  COMMENT_ACTIVITY = "COMMENT_ACTIVITY",
  COMMENT_ACTIVITY_REPLY = "COMMENT_ACTIVITY_REPLY", // あなたの活動報告のコメントに返信が届きました
  FAVORITE_ACTIVITY = "FAVORITE_ACTIVITY",
}
export type NotificationDataTypes = typeof NotificationDataType[keyof typeof NotificationDataType];
